import Service from './service'
import store from '../store'

export default class DetailService {
  /**
   * Permet de récupérer les classes contenant des travaux.
   */
  static async getWorkClassrooms () {
    try {
      await Service.verifyToken()
      return Service.api.get('/ldap/work/classroom', {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Permet de récupérer toutes les classes.
   */
  static async getClassrooms () {
    try {
      await Service.verifyToken()
      return Service.api.get('/ldap/classroom', {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Permet de récupérer tous les étudiants d’une classe.
   * @param {string} classroom
   */
  static async getStudents (classroom) {
    try {
      await Service.verifyToken()
      return await Service.api.post('/ldap/student', {
        classe: classroom
      }, {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
}
